import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bef8c220"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "overflow-y-auto custumScroll",
  style: { height: 'calc(100vh - 16rem)' }
}

import { useRouter } from "vue-router";

	// Déclaration des événements que le composant peut émettre
	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppContainer',
  props: {
		searchbar: {
			type: Object,
			default: {
				type: Object,
				default: {
					enable: false,
					placeholder: "",
					css: "",
					icon: "",
					callback: () => {
						// Code here
					},
				},
			},
		},
		btn_1: {
			type: Object,
			default: {
				type: Object,
				default: {
					enable: false,
					text: "",
					css: "",
					icon: "",
					callback: () => {
						// Code here
					},
				},
			},
		},
		btn_2: {
			type: Object,
			default: {
				type: Object,
				default: {
					enable: false,
					text: "",
					css: "",
					icon: "",
					callback: () => {
						// Code here
					},
				},
			},
		},
		btn_3: {
			type: Object,
			default: {
				type: Object,
				default: {
					enable: false,
					text: "",
					css: "",
					icon: "",
					callback: () => {
						// Code here
					},
				},
			},
		},
		background: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: "Title of the workspace",
		},
		titleFilterSection: {
			type: String,
			default: "Filtre | ",
		},
		enableFilterSection: {
			type: Boolean,
			default: false,
		},
		backButton: {
			type: Boolean,
			default: false,
		},
		labelBackButton: {
			type: String,
			default: "Back Button",
		},
		backButtonAction: {
			type: Function,
			default: () => {
				// Code here
			},
		},
		dotactions: {
			type: Object,
			default: {
				enable: false,
				options: [],
				callback: () => {
					// Code here
				},
			},
		},
	},
  emits: ["search-model"],
  setup(__props, { emit: __emit }) {

	const emit = __emit;

	const props = __props;

	// Émettre les donnees saisies de la barre de recherche
	function emitAdvancedSearchData(e:any) {
		emit("search-model", e);
	}


return (_ctx: any,_cache: any) => {
  const _component_AppWorkspaceHeader = _resolveComponent("AppWorkspaceHeader")!

  return (_openBlock(), _createElementBlock("div", {
    style: { height: 'calc(100vh - 11rem)' },
    class: _normalizeClass({ 'text-white  rounded-2xl bg-card': __props.background, 'p-4 ': true })
  }, [
    _createVNode(_component_AppWorkspaceHeader, {
      title: __props.title,
      titleFilterSection: __props.titleFilterSection,
      enableFilterSection: __props.enableFilterSection,
      backButton: __props.backButton,
      backButtonAction: __props.backButtonAction,
      labelBackButton: __props.labelBackButton,
      btn_1: __props.btn_1,
      btn_2: __props.btn_2,
      btn_3: __props.btn_3,
      searchbar: __props.searchbar,
      dotactions: __props.dotactions,
      onSearchModel: _cache[0] || (_cache[0] = (e) => emitAdvancedSearchData(e))
    }, {
      filter: _withCtx(() => [
        _renderSlot(_ctx.$slots, "filterSection")
      ]),
      _: 3
    }, 8, ["title", "titleFilterSection", "enableFilterSection", "backButton", "backButtonAction", "labelBackButton", "btn_1", "btn_2", "btn_3", "searchbar", "dotactions"]),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})